import React from 'react';
import PropTypes from 'prop-types';

import { formatNumber } from '../utilities/helpers';

const TopTenOrganisations = props => {
  const topPercentage = props.data[0] ? props.data[0].sharePerCent : 1;
  return (
    <div className="TopTenOrganisations">
      <h3 className="content-card_title">Top 10 organisations</h3>
      <p className="content-card_subtitle">
        {formatNumber(props.total)} identifications across top 10 organisation
      </p>
      <ul>
        {props.data.map(organisation => (
          <li key={organisation.name}>
            <p className="TopTenOrganisations_title">{organisation.name}</p>
            <div className="TopTenOrganisations_info">
              <div className="TopTenOrganisations_chart">
                <div
                  className="TopTenOrganisations_chart_bar"
                  style={{
                    width: `${(Math.min(
                      organisation.sharePerCent,
                      topPercentage
                    ) /
                      topPercentage) *
                      100}%`,
                  }}
                />
              </div>
              <div className="TopTenOrganisations_percentage">
                {Math.round(organisation.sharePerCent)}%
              </div>
              {/* <div className="TopTenOrganisations_change">
                {organisation.percentageChange >= 0 ? '+' : '-'}{' '}
                {Math.abs(organisation.percentageChange)}%
              </div> */}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

TopTenOrganisations.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  total: PropTypes.number.isRequired,
};

export default TopTenOrganisations;
